import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { CiSearch } from "react-icons/ci";
import { LiaShoppingBagSolid } from "react-icons/lia";
import braceletsIcon from '../assets/icons/bracelets-icon.png'
import chainIcon from '../assets/icons/chain-icon.png'
import pendantsIcon from '../assets/icons/pendants-icon.png'
import ringIcon from '../assets/icons/ring-icon.png'
import earringIcon from '../assets/icons/earring-icon.png'
import accessoriesIcon from '../assets/icons/accessories-icon.png';
import productImg from '../assets/product-img.png'
import { IoIosArrowDown } from 'react-icons/io';
import { RiDeleteBin6Fill } from "react-icons/ri";
import logo from '../assets/logo.png'
import CategoriesService from '../services/API/CategoriesService';

export const Header = () => {
  const toggleSearch = () => {
    setShowSearch(!showSearch);
  };
  const location = useLocation();
  const [showSearch, setShowSearch] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [showServicesBox, setShowServicesBox] = useState(false);
  const [menuExpanded, setMenuExpanded] = useState(false);
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(null);
  const [showSidebar, setShowSidebar] = useState(false); // State for sidebar visibility
     const [products, setProducts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [productsContent, setProductsContent] = useState([]);
  const fetchCategoryData = async () => {
    try {
      const res = await CategoriesService.getAllCategory();
      setProducts(res.data);
      // if (res.status) {
      //   const products = res.data;
      //   if (products) {
      //     setProductsContent(products);
      //   }
      //   setIsLoading(false);
      // }
    } catch (error) {
      setIsLoading(false);
      console.error("Error fetching product data:", error);
    }
  };
  useEffect(() => {
    fetchCategoryData();
  }, []);
  console.log('products',products);
  
  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleServicesBox = () => {
    setShowServicesBox((prevShowServicesBox) => !prevShowServicesBox);
  };

  const closeMenu = () => {
    setShowServicesBox(false);
    setMenuExpanded(false);
    setActiveSubMenu(null);
    setIsMobileMenuOpen(null);
  };

  const handleMobileMenuToggle = (menuId) => {
    setIsMobileMenuOpen((prevMenuId) => (prevMenuId === menuId ? null : menuId));
  };
  const currentPath = location.pathname;

  const [isOpen, setIsopen] = useState(false);
  const ToggleSidebar = () => {
    isOpen === true ? setIsopen(false) : setIsopen(true);
  }


  const [count, setCount] = useState(1);

  // Function to increment the count
  const increment = () => {
    setCount(count + 1);
  };

  // Function to decrement the count (with a minimum of 1)
  const decrement = () => {
    if (count > 1) {
      setCount(count - 1);
    }
  };
  return (
    <>
      <Navbar expand="lg" style={{ position: "static" }}>
        <Container>
          <Navbar.Brand href="/"><img width={100} src={logo} alt={logo} /></Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll" style={{ justifyContent: 'space-between' }}>
            <Nav className="col-2 my-2 my-lg-0 gap-5"></Nav>

            <Nav className="col-6 my-2 my-lg-0 gap-5">
              <NavLink className={`${location.pathname === "/" ? "header-t-active" : ""} header-t`} exact to="/" activeClassName="active-link">
                <button>HOME</button>
              </NavLink>
              <Nav.Link
                className={`hoverlink none-for-res ${showServicesBox ? 'additional-class' : ''}`}
                onClick={toggleServicesBox}
                onMouseEnter={() => setShowServicesBox(true)}
                onMouseLeave={() => setShowServicesBox(false)}
                style={{ display: "flex", alignItems: "center", gap: "2px" }}
              >
                PRODUCTS
                <IoIosArrowDown />
              </Nav.Link>
              {showServicesBox && (
                <div
                  className="full-width-box"
                  onMouseEnter={() => setShowServicesBox(true)}
                  onMouseLeave={() => setShowServicesBox(false)}
                >
                  <div className="menu_container">
                    <div className="menu_items">
                      <div className="row p-3">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-12 resp-submenu">
                          <div
                            className='header-drpdn-sub-div'
                            id="development-design"
                          >
                            {products.length > 0 ? (
              products.slice(5,12).map((product) => (
                <div key={product.id}>
                              <a className="header-drpdn-sub-div-lst" href={`/category/${product.id}`}>
                                <div>
                                  <img src={product.categoryImage} alt='' />
                                </div>
                                {product.name}
                              </a>


                            </div>
              ))
            ) : (
              <p>Loading products...</p>
            )}
                            {/* <div>
                              <Link className="header-drpdn-sub-div-lst" onClick={closeMenu} to="">
                                <div>
                                  <img src={braceletsIcon} />
                                </div>
                                BRACELETS
                              </Link>


                            </div>
                            <div>
                              <Link className="header-drpdn-sub-div-lst" onClick={closeMenu} to="/category">
                                <div>
                                  <img src={chainIcon} />
                                </div>
                                CHAINS
                              </Link>

                            </div>
                            <div>
                              <Link className="header-drpdn-sub-div-lst" onClick={closeMenu} to="/category">
                                <div>
                                  <img src={pendantsIcon} />
                                </div>
                                PENDANTS
                              </Link>

                            </div>
                            <div>
                              <Link className="header-drpdn-sub-div-lst" onClick={closeMenu} to="/category">
                                <div>
                                  <img src={ringIcon} />
                                </div>
                                RINGS
                              </Link>

                            </div>
                            <div>
                              <Link className="header-drpdn-sub-div-lst" onClick={closeMenu} to="/category">
                                <div>

                                  <img src={earringIcon} />
                                </div>
                                EARRINGS
                              </Link>

                            </div> */}
                            <div>
                              <Link className="header-drpdn-sub-div-lst" onClick={closeMenu} to="/category">
                                <div>
                                  <img src={accessoriesIcon} />
                                </div>
                                ACCESSORIES
                              </Link>

                            </div>
                          </div>
                          {/* desktop End */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <NavLink className={`${location.pathname === "/aboutus" ? "header-t-active" : ""} header-t`} to="/aboutus" activeClassName="active-link">
                <button>ABOUT</button>
              </NavLink>
              <NavLink className={`${location.pathname === "/contactus" ? "header-t-active" : ""} header-t`} to="/contactus" activeClassName="active-link">
                <button>CONTACT</button>
              </NavLink>
            </Nav>

            <Nav className="col-3 ml-auto"> {/* This class will align items to the right */}
              <div className='header-rght-sec'>
                <Nav.Link href="#" className="mr-3" onClick={toggleSearch}>
                  <CiSearch size={20} /> {/* Search icon */}
                </Nav.Link>
                {showSearch && (
                  <input className='header-search-input' type="text" placeholder='Search' />
                )}
                {/* <Link onClick={ToggleSidebar}> */}
                <Link to='/cart'>
                  <LiaShoppingBagSolid className='header-cart-icon' size={20} /> {/* Cart icon */}
                </Link>
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Sidebar */}
      <div className={`sidebar ${isOpen == true ? 'active' : ''}`}>
        <div className="sd-header">
          <LiaShoppingBagSolid size={30} />
        </div>
        <div className="sd-body">
          <div className='row'>
            <div className='col-6'>
              <div className='product-sec-img-div'>
                <img src={productImg} alt='product img' id='productImg' />
              </div>
            </div>
            <div className='col-6'>
              <div className='header-sec-text-sub-div2main'>

                <div className='header-sec-text-sub-div'>
                  <span className='header-sec-text-div-span'>$250</span>
                </div>
                <div className='header-sec-text-sub-div'>
                  <span className='header-sec-text-div-span2'>Quantity</span>
                  <div className='header-sec-text-div-counter-dlt-div'>
                    <div className='header-sec-text-div-counter-div'>
                      <button onClick={decrement}>-</button>
                      <span>{count.toString().padStart(2, '0')}</span>
                      <button onClick={increment}>+</button>
                    </div>
                    <button className='header-sec-text-div-dlt-div'><RiDeleteBin6Fill className='header-sec-text-div-dlt-icon' /></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`sidebar-overlay ${isOpen == true ? 'active' : ''}`} onClick={ToggleSidebar}></div>
    </>
  );
};
